import { apiClient, type ApiClientResponse, type ApiPaginatedResponse } from '@/datasources/apiClient'

export interface Stage {
  name: string
  region: string
  [key: string]: unknown
}

export interface Service {
  id: string
  appId: string
  name: string
  provider: string
  stages: Stage[]
  createdAt: string
  updatedAt: string
}

export const listServicesApi = (
  appId: string,
  page = 1,
  pageSize = 50,
): Promise<ApiPaginatedResponse<Service>> =>
  apiClient
    .get(`/api/v1/apps/${appId}/services`, { params: { page, pageSize } })
    .then((r) => r.data)

export const getServiceApi = (appId: string, serviceId: string): Promise<ApiClientResponse<Service>> =>
  apiClient.get(`/api/v1/apps/${appId}/services/${serviceId}`).then((r) => r.data)

export const createServiceApi = (appId: string, data: { name: string; provider: string; stages?: Stage[] }): Promise<ApiClientResponse<Service>> =>
  apiClient.post(`/api/v1/apps/${appId}/services`, data).then((r) => r.data)

export const listStagesApi = (appId: string, serviceId: string): Promise<ApiClientResponse<Stage[]>> =>
  apiClient.get(`/api/v1/apps/${appId}/services/${serviceId}/stages`).then((r) => r.data)
